import React, { useEffect, useRef, useState } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

export default function SectionContentEditor({ value = '', onChange, id, disabled = false }) {
    const host = useRef(null);
    const editor = useRef(null);
    const change = useRef(onChange);
    const [source, setSource] = useState(false);
    change.current = onChange;
    useEffect(() => {
        const element = document.createElement('div');
        host.current.appendChild(element);
        const quill = new Quill(element, {
            theme: 'snow',
            placeholder: 'Write your content…',
            modules: { toolbar: [[{ header: [2, 3, false] }], ['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], [{ align: [] }], ['link', 'blockquote'], ['clean']] },
        });
        quill.root.setAttribute('aria-label', 'Content editor');
        editor.current = quill;
        const handleChange = () => change.current(quill.getText().trim() ? quill.root.innerHTML : '');
        quill.on('text-change', handleChange);
        const container = host.current;
        return () => { quill.off('text-change', handleChange); editor.current = null; container.innerHTML = ''; };
    }, []);
    useEffect(() => {
        const quill = editor.current;
        if (quill && !source && quill.root.innerHTML !== (value || '')) {
            quill.setContents(quill.clipboard.convert(value || ''), 'silent');
        }
    }, [value, source]);
    useEffect(() => { editor.current?.enable(!disabled); }, [disabled]);
    return <div className="section-content-editor">
        <div className="section-editor-toolbar"><label htmlFor={source ? id : undefined}>Content</label><button type="button" disabled={disabled} className="btn btn-sm btn-outline-secondary" aria-pressed={source} onClick={() => setSource(!source)}>{source ? 'Visual editor' : 'Edit HTML'}</button></div>
        <div ref={host} hidden={source} />
        {source && <textarea disabled={disabled} id={id} className="form-control section-html" rows={9} value={value || ''} onChange={event => onChange(event.target.value)} spellCheck={false} />}
        <small className="text-muted">Use the toolbar to format text, add lists or insert links.</small>
    </div>;
}
